import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, ViewEncapsulation } from '@angular/core';
import { ButtonComponent, RootDirective, TooltipDirective } from '@pure/hive';
import { Subject } from 'rxjs';
import {
    FbNorwayEolRenderInfo,
    RECOMMENDATION_ACTION_EVENT_TOKEN,
    RecommendationActionEvent,
} from '../../../../data/models/recommendations.models';
import { registerAsDialogPlugin } from '../../services/recommendation-component-registry.service';

/** Stable registry key for this plugin. Used as the lookup name on the corresponding RenderInfo. */
export const FB_NORWAY_EOL_DIALOG_PLUGIN_NAME = 'FbNorwayEolDialogPluginComponent';

/**
 * Dialog component for the FlashBlade end-of-life (prorec-eol-fb-norway) recommendation.
 *
 * Displayed when the user clicks an end-of-life recommendation card. The dialog body is a
 * detail table showing the current model and, when known, the end-of-support date.
 * There is no recommended configuration to quote, so the footer offers Dismiss, Cancel and
 * Contact Account Team, and a line under the title points to it. Footer actions are routed
 * back to the container via
 * {@link RECOMMENDATION_ACTION_EVENT_TOKEN}.
 */
@Component({
    selector: 'fb-norway-eol-dialog-plugin',
    templateUrl: './fb-norway-eol-dialog-plugin.component.html',
    styleUrls: ['./fb-norway-eol-dialog-plugin.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
    imports: [ButtonComponent, DatePipe, RootDirective, TooltipDirective],
    encapsulation: ViewEncapsulation.None,
})
export class FbNorwayEolDialogPluginComponent {
    renderInfo = input.required<FbNorwayEolRenderInfo>();

    readonly RecommendationActionEvent = RecommendationActionEvent;

    private readonly recommendationActionEvent$ = inject<Subject<RecommendationActionEvent>>(
        RECOMMENDATION_ACTION_EVENT_TOKEN,
        { optional: true },
    );

    handleActionEvent(action: RecommendationActionEvent): void {
        this.recommendationActionEvent$?.next(action);
    }
}

registerAsDialogPlugin(FB_NORWAY_EOL_DIALOG_PLUGIN_NAME, FbNorwayEolDialogPluginComponent);
